import { __rest, __assign } from 'tslib';

var useSelectLegacy = function (props) {
    var label = props.label, placeholder = props.placeholder, selectedOptions = props.selectedOptions, selectableContext = __rest(props, ["label", "placeholder", "selectedOptions"]);
    var resolvedLabel = label;
    if (!label) {
        resolvedLabel = (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length)
            ? selectedOptions.map(function (o) { return o.label; }).join(", ")
            : placeholder;
    }
    return __assign({ label: resolvedLabel, placeholder: placeholder, selectedOptions: selectedOptions }, selectableContext);
};

export { useSelectLegacy };
//# sourceMappingURL=useSelectLegacy.js.map
